export { default } from './index.vue'



// WEBPACK FOOTER //
// ./packages/dof-swipe-list/index.js